import React from 'react'
import Box from '@material-ui/core/Box'
import Styles from '../Styles/Styles'
import {useParams} from "react-router-dom"
import Wrapper from "../Components/Wrapper";

function MultipleKeysFound() {
    const classes = Styles({});
    let { email } = useParams();

    return (
        <Wrapper>
            <Box className={classes.logoContainer}><img width="140" alt="ISN" src={process.env.REACT_APP_ISN_LOGO} /></Box>
            <p className={classes.info}>
                <p className={classes.emailBold}>{email}</p> is associated with multiple ISN accounts, a list of company keys has been emailed to you.
            </p>
            <Box className={classes.linkBox}>
                <p className={classes.sameLineLink}><a href={process.env.REACT_APP_FIND_ISN_CONTACT} className={classes.link}>CONTACT US</a></p>
                <p className={classes.sameLineLinkPipe}></p>
                <p className={classes.sameLineLink}><a href="/" className={classes.link}>TRY WITH DIFFERENT EMAIL</a></p>
                <p className={classes.sameLineLinkPipe}></p>
                <p className={classes.sameLineLink}><a href={process.env.REACT_APP_FIND_ISN_HOME} className={classes.link}>Home</a></p>
            </Box>
        </Wrapper>
    );
};

export default MultipleKeysFound